<template>
  <CxButton
    :variant="customVariant"
    :customColor="mainColor"
    :icon="icon"
    :size="size"
    :isLoading="isLoading"
    :disabled="disabled"
  >
    <slot />
  </CxButton>
</template>

<script setup lang="ts">
import { CxButton } from "@/designSystem";
import useAccountStore from "@/apps/shared/organization/store/accountStore";
import { storeToRefs } from "pinia";

const { mainColor } = storeToRefs(useAccountStore());

const props = defineProps({
  isOutlined: {
    type: Boolean,
    default: false,
  },

  icon: {
    type: String,
    required: false,
  },

  size: {
    type: String as () => "sm" | "md" | "lg" | undefined,
    required: false,
  },

  isLoading: {
    type: Boolean,
    default: false,
  },

  disabled: {
    type: Boolean,
    default: false,
  },
});

const customVariant = props.isOutlined ? "outline-custom" : "custom";
</script>
